import { render, staticRenderFns } from "./TagDefinitionsEdit.vue?vue&type=template&id=6db96ae0&scoped=true&"
import script from "./TagDefinitionsEdit.vue?vue&type=script&lang=js&"
export * from "./TagDefinitionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagDefinitionsEdit.vue?vue&type=style&index=0&id=6db96ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db96ae0",
  null
  
)

export default component.exports